export const DASHBOARD_SECTIONS = {
  activeApplications: 'active-applications',
  contracts: 'contracts',
  rentalContracts: 'rental-contracts',
  permits: 'permits',
  serviceProviders: 'service-providers',
  properties: 'properties',
} as const;

export type DashboardSectionId = (typeof DASHBOARD_SECTIONS)[keyof typeof DASHBOARD_SECTIONS];

export function scrollToDashboardSection(sectionId: string) {
  document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
